import React, { useEffect, useState } from 'react';
import { getRegistrations, deleteRegistration } from './api';
import ActivationForm from './ActivationForm';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  CircularProgress,
} from '@mui/material';

export default function RegistrationList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  async function load() {
    setLoading(true);
    try {
      const data = await getRegistrations();
      // Convert is_activated to number to avoid string truthy issues
      const normalized = data.map(r => ({ ...r, is_activated: Number(r.is_activated) }));
      setRows(normalized);
    } catch (e) {
      console.error(e);
      alert('خطا در بارگذاری ثبت‌نام‌ها');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  async function handleDelete(id) {
    if (!window.confirm('آیا از حذف این ثبت‌نام اطمینان دارید؟')) return;
    try {
      const res = await deleteRegistration(id);
      if (res.success) {
        alert('با موفقیت حذف شد ✅');
        load();
      } else {
        alert(res.message || 'خطا در حذف');
      }
    } catch {
      alert('Server error');
    }
  }

  return (
    <Box sx={{ p: 2, direction: 'rtl' }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        درخواست‌های ثبت‌نام محصولات
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ borderRadius: 2, overflow: 'hidden' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#1976d2' }}>
                {['#', 'شماره سریال', 'نام خریدار', 'تلفن', 'تاریخ ثبت', 'وضعیت فعال‌سازی', 'عملیات'].map((head, index) => (
                  <TableCell
                    key={index}
                    sx={{ color: 'white', fontWeight: 600, textAlign: 'center' }}
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r, i) => (
                <TableRow
                  key={r.id}
                  sx={{
                    backgroundColor: i % 2 === 0 ? '#f7f7f7' : '#ffffff',
                    '&:hover': {
                      backgroundColor: '#e3f2fd',
                      transition: '0.2s',
                    },
                  }}
                >
                  <TableCell sx={{ textAlign: 'center' }}>{i + 1}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{r.product_serial_number}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{r.person_name}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{r.phone_number}</TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>{r.registration_date}</TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'center',
                      color: r.is_activated === 1 ? 'green' : 'red',
                      fontWeight: 600,
                    }}
                  >
                    {r.is_activated === 1 ? 'فعال شده' : 'غیرفعال'}
                  </TableCell>
                  <TableCell sx={{ textAlign: 'center' }}>
                    {r.is_activated !== 1 && (
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        sx={{ ml: 1 }}
                        onClick={() => setSelected(r)}
                      >
                        فعال‌سازی
                      </Button>
                    )}
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleDelete(r.id)}
                    >
                      حذف 🗑
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {selected && (
        <ActivationForm
          registration={selected}
          onClose={() => {
            setSelected(null);
            load();
          }}
        />
      )}
    </Box>
  );
}
